export { default as WebPayment } from './webPayment/webPayment'
